import script from "./Objective.vue?vue&type=script&setup=true&lang=js"
export * from "./Objective.vue?vue&type=script&setup=true&lang=js"

import "./Objective.vue?vue&type=style&index=0&id=262f7e80&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262f7e80"]])

export default __exports__